import { QueryClient } from "@tanstack/react-query";
import { Map } from "immutable";
import { Organization } from "@/interfaces/organization";
import { Person } from "@/interfaces/person";
import { PersonWithVoices } from "@/queryOptions/persons";

export const updateQueryClientOrganizations = (
  queryClient: QueryClient,
  organizations: Organization[],
) => {
  let organizationMap: Map<number, Organization> =
    queryClient.getQueryData(["organizations"]) ?? Map();
  organizations.forEach((organization) => {
    organizationMap = organizationMap.set(organization.id, organization);
  });
  queryClient.setQueryData(["organizations"], organizationMap);
};

export const updateQueryClientPersons = (
  queryClient: QueryClient,
  persons: PersonWithVoices[],
) => {
  let personMap: Map<number, Person> =
    queryClient.getQueryData(["persons"]) ?? Map();
  let voiceIdPersonMap: Map<number, Person> =
    queryClient.getQueryData(["voices"]) ?? Map();
  persons.forEach((person) => {
    personMap = personMap.set(person.id, person);
    person.voices.forEach((voice) => {
      voiceIdPersonMap = voiceIdPersonMap.set(voice.id, person);
    });
  });
  queryClient.setQueryData(["persons"], personMap);
  queryClient.setQueryData(["voices"], voiceIdPersonMap);
};